import moment from 'moment';
import {CurrencyService} from '../../app/danh-muc/tien-te/CurrencyService';

export class FormatDisplay {
  static date(value: any, format?: string): string {
    if (value) {
      return moment(value).format(format || 'DD/MM/YYYY');
    }
    return value;
  }

  static dateTime(value: any): any {
    if (value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    }
    return value;
  }

  static time(value: any): any {
    if (value) {
      return moment(value).format('HH:mm');
    }
  }

  static locales = 'en-US';

  static number(value: any, options?: any): any {
    if (value === null || value === undefined || value === '') {
      return value;
    }
    return Intl.NumberFormat(this.locales, options).format(value);
  }

  static currencies;

  static loadCurrencies(): Promise<any> {
    return CurrencyService.getList({}).then(({items}) => {
      this.currencies = items;
    });
  }

  static getFractionDigits(rowData: any, fieldName?: string): any {
    let fractionDigits = 0;
    if (rowData && rowData.currencyId) {
      this.currencies.forEach((currency) => {
        if (currency.id === rowData.currencyId) {
          switch (fieldName) {
            case 'unitPrice':
              if (currency.formatPrice > 0) {
                fractionDigits = currency.formatPrice;
              }
              break;
            case 'vatAmount':
              if (currency.formatTaxDetail > 0) {
                fractionDigits = currency.formatTaxDetail;
              }
              break;
            case 'quantity':
              if (currency.formatQuantity > 0) {
                fractionDigits = currency.formatQuantity;
              }
              break;
            default:
              if (currency.formatTotal > 0) {
                fractionDigits = currency.formatTotal;
              }
          }
        }
      });
    }
    return {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    };
  }

  static getFractionDigitsDefault(fractionDigits: any): any {
    return {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    };
  }
}

export const stringOperations = [
  {value: '=', label: 'Bằng'},
  {value: '!=', label: 'Khác'},
  {value: 'LIKE', label: 'Chứa'},
  {value: 'Start', label: 'Bắt đầu'},
  {value: 'Ends', label: 'Kết thúc'},
  {value: 'LIKEArray', label: 'Chứa danh sách'},
  {value: 'NOTLIKEArray', label: 'Không chứa'},
  {value: 'NotHasValue', label: 'Trống'},
  {value: 'HasValue', label: 'Không trống'}
];
export const numericOperations = [
  {value: '=', label: 'Bằng'},
  {value: '!=', label: 'Khác'},
  {value: '>', label: 'Lớn hơn'},
  {value: '>=', label: 'Lớn hơn hoặc bằng'},
  {value: '<', label: 'Nhỏ hơn'},
  {value: '<=', label: 'Nhỏ hơn hoặc bằng'},
  {value: 'NotHasValue', label: 'Trống'},
  {value: 'HasValue', label: 'Không trống'}
];
export const dateOperations = [...numericOperations];

let _allOperations = [...stringOperations];
for (const numericOperation of numericOperations) {
  if (!_allOperations.find(it => it.value === numericOperation.value)) {
    _allOperations.push(numericOperation);
  }
}
export const allOperations = _allOperations;